import { render, staticRenderFns } from "./Retencao.vue?vue&type=template&id=4ffa1a72"
import script from "./Retencao.vue?vue&type=script&lang=js"
export * from "./Retencao.vue?vue&type=script&lang=js"
import style0 from "./Retencao.vue?vue&type=style&index=0&id=4ffa1a72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports